import React from "react";
import styled from "styled-components";
import AddIconSrc from "../../../../../images/icons/add-icon.svg";
import ThreeDotMenuIcon from "../../../../../images/icons/3-dot-menu-icon.png";
import SelectedStarIcon from "../../../../../images/icons/selected-star-icon.png";
import UnselectedStarIcon from "../../../../../images/icons/unselected-star-icon.png";
import Tabs from "../../../Components/Main/Sidebar/Tabs";
import Tab from "../../../Components/Main/Sidebar/Tab";
import TabContent from "../../../Components/Main/Sidebar/TabContent";
import TabContentLoading from "../../../Components/Main/Sidebar/TabContentLoading";
import MenuButton from "../../../Components/Main/Sidebar/MenuButton";
import MenuSearchInput from "../../../Components/Main/Sidebar/MenuSearchInput";
import AddIcon from "../../../Components/Main/Sidebar/AddIcon";
import api from '../../../../util/api';
import ModalOption from "../../../Components/Main/Modals/ModalOption";
import MenuSelect from "../../../Components/Main/Modals/MenuSelect";
import {ToastContainer, toast} from 'react-toastify';
import SharedLabel from "../../../Components/Main/Sidebar/SharedLabel";

const Pagination = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding-bottom: 20px;
    background: white;
    padding-top: 20px;
    .pagination-pages > span:not(.visible) {
        display: none;
    }
`;

const PaginationRefresh = styled.a`
    text-decoration: underline;
    text-align: center;
    width: 100%;
    display: block; 
    font-size: 14px;
    color: #888888;
    cursor: pointer;
`;

const Pages = styled.div`
    text-align: center;
    margin-top: 20px;    
`;

const PageArrow = styled.span`
    color: #888888;
    font-size: 23px;
    padding: 0 7px;
    line-height: 32px;
`;

const Page = styled.span`
    color: #888888;
    font-size: 23px;
    padding: 0 7px;
    line-height: 32px;
    cursor: pointer;
    
    ${(props) => (props.active ? {
    'background': '#5562C0',
    'color': 'white',
    'width': '30px',
    'height': '30px',
    'display': 'inline-block !important',
    'border-radius': '45px',
} : '')}
`;

const FavoriteTrigger = styled.div`
    float: right;
    height: 18px;
    position: absolute;
    top: 28px;
    right: 0;
    cursor: pointer;
    width: 20px;
    
    img {
        width: 100%;
    }
`;

const PaginationResults = styled.div`
    
    color: #888888;
    font-size: 14px;
    text-align: center;
    border-top: 1px solid lightgrey;
    padding-top: 20px;
    padding-bottom: 5px;
    margin-top: -10px;
`;

const ThreeDotMenuClose = styled.div`

    position: absolute;
    top: 6px;
    right: 6px;
    cursor: pointer;
    color: grey;
`;

const ThreeDotMenuTrigger = styled.img`
    float: right;
    height: 18px;
    position: absolute;
    top: 0;
    right: 7px;
    cursor: pointer;
`;

const SortWrapper = styled.div`
    overflow: auto;
    width: 100%;
`;

const ClipName = styled.span`
    cursor: pointer;
    font-weight: 700;
`;

const SortLabel = styled.span`   
 width: 35%;
    float: left;
    font-size: 18px;
    color: #737697;
    padding-top: 19px;
`;

const SortInputWrapper = styled.span`
width: 65%;
float: left;
`;

const ThreeDotMenu = styled.div`
    top: 0;
    right: 0;
    
    position: absolute;
    background: white; 
    border: 2px solid lightgrey;
    padding: 10px;
    box-shadow: 5px 5px 25px #0000002e;
    display: none;   
    z-index: 9;
   
    
    
    ${(props) => (props.open ? {
    'display': 'block'
} : '')}
`;

const ThreeDotMenuItem = styled.div`

        display: ${(props) => (props.hidden ? "none" : "block")};
    margin-bottom: 6px;
    border-bottom: 1px solid lightgrey;
    padding-bottom: 6px;
    width: 145px;
    cursor: pointer;
    
    
    ${(props) => (props.no_border ? {
    'border': 'none !important',
    'margin': '0 !important',
    'padding': '0 !important',
} : '')}
`;

const ClipMenuWrapper = styled.section`
    display: none;
    background: white;
    
    ${(props) => (props.open ? {
    'display': 'block'
} : '')}
`;

const ClipsList = styled.div`
`;
const Clip = styled.div`
    text-decoration: none;
    color: black;
    cursor: pointer;
        display: ${(props) => (props.hidden ? "none" : "block")};
        
    border-bottom: 1px solid lightgrey;
    padding-bottom: 6px;
`;
const ClipVideo = styled.div`
    width: 100%;
    padding-top: 57%;
    background: gray;
    display: none;
`;
const ClipHeading = styled.h3`
    font-size: 18px; 
    line-height: 21px;
    font-weight: 700;
    position: relative;
    
    padding-right: 30px;
`;
const ClipSubheading = styled.p`
        font-size: 12px;
    line-height: 17px;
    margin-top: 6px;
`;

const FontAwesomeIcon = styled.i`
color: #515151;
    margin-right: 15px;
    top: 1px;
    position: relative;
    cursor: pointer;
        display: ${(props) => (props.hidden ? "none" : "inline-block")};
`;

export default class ClipMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tab_open: !this.props.lesson_id || (this.props.lesson_id && !this.props.isInstructor) ? 2 : 1,
            three_dot_menu_open: null
        };
    }

    setTab(val) {
        this.setState({tab_open: val});
    }

    setThreeDotMenuOpen(val) {
        this.setState({three_dot_menu_open: val});
    }

    render() {
        return (
            <div>
                <ClipMenuWrapper open={this.props.open}>
                    <Tabs>
                        <Tab hidden={!this.props.lesson_id || (this.props.lesson_id && !this.props.isInstructor)} onClick={() => {this.setTab(1)}}
                             open={this.state.tab_open === 1}>{"Student Clips"}</Tab>
                        <Tab fullwidth={!this.props.lesson_id} onClick={() => {this.setTab(2)}}
                             open={this.state.tab_open === 2}>{"Clip Library"}</Tab>
                    </Tabs>
                    <TabContent open={this.state.tab_open === 1}>
                        <TabContentLoading open={this.props.clipsLoading}><i className="fa fa-spinner"></i></TabContentLoading>
                        <MenuButton hidden={this.props.recordAllSessions} onClick={this.props.newLessonClipAction}>
                            <AddIcon src={AddIconSrc}/>
                            {"Create New Clip"}
                        </MenuButton>
                        <MenuSearchInput onKeyDown={this.props.searchLessonClips}
                                         onChange={this.props.searchLessonClips}
                                         placeholder="Search Clips"></MenuSearchInput>

                        <SortWrapper>
                            <SortLabel>Sort By:</SortLabel>
                            <SortInputWrapper>
                                <MenuSelect onChange={(e) => {this.props.selectSort(e, 'lessonClips')}}>
                                    <ModalOption value="created_at">Created Date</ModalOption>
                                    <ModalOption value="name">Name</ModalOption>
                                    <ModalOption value="favorite">Favorites</ModalOption>
                                </MenuSelect> 
                            </SortInputWrapper>
                        </SortWrapper>
                        {this.props.studentPaginationMeta ? (
                            <PaginationResults>showing {this.props.lessonClips.length} of {this.props.studentPaginationMeta ? this.props.studentPaginationMeta.total : 0} results</PaginationResults>
                        ) : (
                            <></>
                        )}
                        {this.props.lessonClips && (
                            <ClipsList>
                            {Object.keys(this.props.lessonClips).map((item, index) => (
                                <Clip hidden={this.props.lessonClips[item].status != 'uploaded'} target="_blank"
                                      href={this.props.lessonClips[item].path} key={this.props.lessonClips[item].id}>
                                    <ClipVideo onClick={() => this.props.openClipAction(this.props.lessonClips[item])}/>

                                    <ClipHeading>
                                        <ClipName onClick={() => this.props.openClipAction(this.props.lessonClips[item])}>{this.props.lessonClips[item].name}</ClipName>

                                        <ClipSubheading>
                                            <SharedLabel
                                                full={this.props.lessonClips[item].full_label+' - '+this.props.lessonClips[item].created_at}
                                                short={this.props.lessonClips[item].short_label+' - '+this.props.lessonClips[item].created_at}>
                                            </SharedLabel>
                                        </ClipSubheading>
                                        <ThreeDotMenuTrigger onClick={() => {this.setThreeDotMenuOpen(this.props.lessonClips[item].id)}} src={ThreeDotMenuIcon}></ThreeDotMenuTrigger>
                                        <FavoriteTrigger onClick={(e) => {
                                            e.preventDefault();
                                            api().post('/fav', {
                                                type: 'clip',
                                                item_id: this.props.lessonClips[item].id
                                            }).then((response) => {
                                                if(response.data.success) {
                                                
                                                     toast.success(!this.props.lessonClips[item].favorite ? 'Success! Clip added to favorites!' : 'Success! Clip removed from favorites!', {
                                                        position: "top-right",
                                                        autoClose: 5000,
                                                        hideProgressBar: true,
                                                        closeOnClick: true,
                                                    });
                                                    this.props.pullClips(true, this.props.studentPaginationMeta.current_page);
                                                    // this.props.lessonClips[item].favorite = !this.props.lessonClips[item].favorite;
                                                }
                                            });
                                        }}><img src={this.props.lessonClips[item].favorite ? SelectedStarIcon : UnselectedStarIcon}/></FavoriteTrigger>
                                        <ThreeDotMenu open={this.state.three_dot_menu_open == this.props.lessonClips[item].id}>
                                            <ThreeDotMenuClose onClick={() => {this.setThreeDotMenuOpen(null)}}>X</ThreeDotMenuClose>
                                            <ThreeDotMenuItem
                                                onClick={() => this.props.openClipAction(this.props.lessonClips[item])}>
                                                <FontAwesomeIcon
                                                    className="fas fa-play"></FontAwesomeIcon>
                                                Play
                                            </ThreeDotMenuItem>
                                            <ThreeDotMenuItem hidden={!this.props.lesson_id} onClick={(e) => {
                                            e.preventDefault();
                                            api().post('/share', {
                                                type: 'clip',
                                                id: this.props.lessonClips[item].id,
                                                session_id: this.props.lesson_id
                                            }).then((response) => {
                                                if(response.data.success) {
                                                     toast.success('Success! Clip shared!', {
                                                        position: "top-right",
                                                        autoClose: 5000,
                                                        hideProgressBar: true,
                                                        closeOnClick: true,
                                                    });
                                                    this.props.pullClips();
                                                }
                                            });
                                        }}>
                                                <FontAwesomeIcon
                                                    className="fas fa-share-square" ></FontAwesomeIcon>
                                                Share
                                            </ThreeDotMenuItem>
                                            <ThreeDotMenuItem hidden={!this.props.lessonClips[item].can_delete} onClick={(e) => {
                                e.preventDefault();
                                var r = confirm("Are you sure you want to delete the Clip?");
                                if (r == true) {

                                  api().delete('/clips/'+this.props.lessonClips[item].id).then((response) => {
                                    this.props.pullClips();
                                  }).catch((error) => {
                                    console.error('Failed to delete clip', error);
                                  });
                                }
                            }}>
                                                <FontAwesomeIcon className="fas fa-trash"></FontAwesomeIcon>
                                                Delete
                                            </ThreeDotMenuItem>
                                            <ThreeDotMenuItem
                                                hidden={!this.props.lessonClips[item].can_delete}
                                                no_border={true}
                                                onClick={(e) => {e.preventDefault();this.props.editClipAction(this.props.lessonClips[item].id)}}
                                            >
                                                <FontAwesomeIcon className="fas fa-edit"></FontAwesomeIcon>
                                                Edit
                                            </ThreeDotMenuItem>

                                        </ThreeDotMenu>
                                    </ClipHeading>
                                </Clip>
                            ))}
                        </ClipsList>
                        )}

                        <Pagination>
                            {this.props.studentPaginationMeta ? (
                                <>
                                <PaginationRefresh
                                    onClick={() => {this.props.pullClips(false, this.props.studentPaginationMeta.current_page)}}>Refresh
                                    results</PaginationRefresh>
                                <Pages className="pagination-pages">
                                    {this.props.studentPaginationMeta.links.map((item, index) => (
                                        <React.Fragment key={index}>
                                        {(item.label == '...' || (index > 0 && (item.label !== '<' && item.label !== '>' && index <= item.label))) ? (
                                            <span index={index}
                                                  className={this.props.studentPaginationMeta.current_page - 1 == item.label || this.props.studentPaginationMeta.current_page + 1 == item.label || item.active || item.label == '...' || index == 0 || index == 1 || index == 2 || item.label == this.props.studentPaginationMeta.last_page || item.label == this.props.studentPaginationMeta.last_page - 1 || item.label == this.props.studentPaginationMeta.last_page - 2 ? 'visible pagination-page-wrapper' : 'pagination-page-wrapper'}
                                                  key={index}>
                                        <Page className="pagination-page"
                                              onClick={() => {this.props.pullClips(false, item.label);}}
                                              active={item.active}>{item.label}</Page>
                                        </span>
                                        ) : (
                                            <>
                                            {(index == 0) ? (


                                                <span index={index}
                                                      className={'visible pagination-page-wrapper'}
                                                      key={index}>
                                            <PageArrow
                                                className="visible"
                                                onClick={() => {this.props.pullClips(false, this.props.studentPaginationMeta.current_page == 1 ? 1 : this.props.studentPaginationMeta.current_page - 1);}}>
                                                {"<"}
                                            </PageArrow>
                                            </span>
                                            ) : (

                                                <span index={index}
                                                      className={'visible pagination-page-wrapper'}
                                                      key={index}>
                                            <PageArrow
                                                className="visible"
                                                onClick={() => {this.props.pullClips(false, this.props.studentPaginationMeta.current_page == this.props.studentPaginationMeta.last_page ? this.props.studentPaginationMeta.last_page : this.props.studentPaginationMeta.current_page + 1);}}>
                                                {">"}
                                            </PageArrow>
                                            </span>
                                            )}
                                            </>
                                        )}
                                        </React.Fragment>
                                    ))}
                                </Pages>
                                </>
                            ) : (
                                <></>
                            )}
                        </Pagination>
                    </TabContent>
                    <TabContent open={this.state.tab_open === 2}>

                                                 <TabContentLoading open={this.props.clipsLoading}><i className="fa fa-spinner"></i></TabContentLoading>
                        <MenuButton hidden={this.props.recordAllSessions || !this.props.lesson_id} onClick={this.props.newClipAction}>
                            <AddIcon src={AddIconSrc}/>
                            {"Create New Clip"}
                        </MenuButton>
                        {!this.props.lesson_id ? (
                            <MenuButton onClick={() => {
            window.location.href = '/private';}}>
                                <AddIcon src={AddIconSrc}/>
                                {"Create New Clip"}
                            </MenuButton>
                        ) : (
                            <></>
                        )}
                        <MenuSearchInput onKeyDown={this.props.searchMyClips} onChange={this.props.searchMyClips}
                                         placeholder="Search Clips"></MenuSearchInput>


                        <SortWrapper>
                            <SortLabel>Sort By:</SortLabel>
                            <SortInputWrapper>
                                <MenuSelect onChange={(e) => {this.props.selectSort(e, 'myClips')}}>
                                    <ModalOption value="created_at">Created Date</ModalOption>
                                    <ModalOption value="name">Name</ModalOption>
                                    <ModalOption value="favorite">Favorites</ModalOption>
                                </MenuSelect>
                            </SortInputWrapper>
                        </SortWrapper>

                        {this.props.paginationMeta ? (
                            <PaginationResults>showing {this.props.yourClips.length} of {this.props.paginationMeta ? this.props.paginationMeta.total : 0} results</PaginationResults>
                        ) : (
                            <></>
                        )}
                        {this.props.yourClips && (
                            <ClipsList>
                            {Object.keys(this.props.yourClips).map((item, index) => (
                                <Clip hidden={this.props.yourClips[item].status != 'uploaded'} target="_blank"
                                      href={this.props.yourClips[item].path} key={this.props.yourClips[item].id}>
                                    <ClipVideo onClick={() => this.props.openClipAction(this.props.yourClips[item])}/>

                                    <ClipHeading>
                                        <ClipName onClick={() => this.props.openClipAction(this.props.yourClips[item])}>{this.props.yourClips[item].name}</ClipName>

                                        <ClipSubheading>
                                            <SharedLabel
                                                full={this.props.yourClips[item].full_label+' - '+this.props.yourClips[item].created_at}
                                                short={this.props.yourClips[item].short_label+' - '+this.props.yourClips[item].created_at}>
                                            </SharedLabel>
                                        </ClipSubheading>
                                        <ThreeDotMenuTrigger onClick={() => {this.setThreeDotMenuOpen(this.props.yourClips[item].id)}} src={ThreeDotMenuIcon}></ThreeDotMenuTrigger>
                                        <FavoriteTrigger onClick={(e) => {
                                            e.preventDefault();
                                            api().post('/fav', {
                                                type: 'clip',
                                                item_id: this.props.yourClips[item].id
                                            }).then((response) => {
                                                if(response.data.success) {
                                                
                                                     toast.success(!this.props.yourClips[item].favorite ? 'Success! Clip added to favorites!' : 'Success! Clip removed from favorites!', {
                                                        position: "top-right",
                                                        autoClose: 5000,
                                                        hideProgressBar: true,
                                                        closeOnClick: true,
                                                    });
                                                     this.props.pullClips(false, this.props.paginationMeta.current_page);
                                                   
                                                    // this.props.yourClips[item].favorite = !this.props.yourClips[item].favorite;
                                                }
                                            });
                                        }}><img src={this.props.yourClips[item].favorite ? SelectedStarIcon : UnselectedStarIcon}/></FavoriteTrigger>
                                        <ThreeDotMenu open={this.state.three_dot_menu_open == this.props.yourClips[item].id}>
                                            <ThreeDotMenuClose onClick={() => {this.setThreeDotMenuOpen(null)}}>X</ThreeDotMenuClose>
                                            <ThreeDotMenuItem
                                                onClick={() => this.props.openClipAction(this.props.yourClips[item])}>
                                                <FontAwesomeIcon
                                                    className="fas fa-play"></FontAwesomeIcon>
                                                Play
                                            </ThreeDotMenuItem>
                                            <ThreeDotMenuItem hidden={!this.props.lesson_id} onClick={(e) => {
                                            e.preventDefault();
                                            api().post('/share', {
                                                type: 'clip',
                                                id: this.props.yourClips[item].id,
                                                session_id: this.props.lesson_id
                                            }).then((response) => {
                                                if(response.data.success) {
                                                     toast.success('Success! Clip shared!', {
                                                        position: "top-right",
                                                        autoClose: 5000,
                                                        hideProgressBar: true,
                                                        closeOnClick: true,
                                                    }); 
                                                    this.props.pullClips();
                                                }
                                            });
                                        }}>
                                                <FontAwesomeIcon
                                                                 className="fas fa-share-square" ></FontAwesomeIcon>
                                                Share
                                            </ThreeDotMenuItem>
                                            <ThreeDotMenuItem hidden={!this.props.yourClips[item].can_delete} onClick={(e) => {
                                e.preventDefault();
                                var r = confirm("Are you sure you want to delete the Clip?");
                                if (r == true) {

                                  api().delete('/clips/'+this.props.yourClips[item].id).then((response) => {
                                    this.props.pullClips();
                                  }).catch((error) => {
                                    console.error('Failed to delete clip', error);
                                  });
                                }
                            }}>
                                                <FontAwesomeIcon className="fas fa-trash"></FontAwesomeIcon>
                                                Delete
                                            </ThreeDotMenuItem>
                                            <ThreeDotMenuItem
                                                hidden={!this.props.yourClips[item].can_delete}
                                                no_border={true}
                                                onClick={(e) => {e.preventDefault();this.props.editClipAction(this.props.yourClips[item].id)}}
                                            >
                                                <FontAwesomeIcon className="fas fa-edit"></FontAwesomeIcon>
                                                Edit
                                            </ThreeDotMenuItem>

                                        </ThreeDotMenu>
                                    </ClipHeading>
                                </Clip>
                            ))}
                        </ClipsList>
                        )}
                        <Pagination>
                            {this.props.paginationMeta ? (
                                <>
                                <PaginationRefresh
                                    onClick={() => {this.props.pullClips(false, this.props.paginationMeta.current_page)}}>Refresh
                                    results</PaginationRefresh>
                                <Pages className="pagination-pages">
                                    {this.props.paginationMeta.links.map((item, index) => (
                                        <React.Fragment key={index}>
                                        {(item.label == '...' || (index > 0 && (item.label !== '<' && item.label !== '>' && index <= item.label))) ? (
                                            <span index={index}
                                                  className={this.props.paginationMeta.current_page - 1 == item.label || this.props.paginationMeta.current_page + 1 == item.label || item.active || item.label == '...' || index == 0 || index == 1 || index == 2 || item.label == this.props.paginationMeta.last_page || item.label == this.props.paginationMeta.last_page - 1 || item.label == this.props.paginationMeta.last_page - 2 ? 'visible pagination-page-wrapper' : 'pagination-page-wrapper'}                                                  key={index}>
                                        <Page className="pagination-page"
                                              onClick={() => {this.props.pullClips(false, item.label);}}
                                              active={item.active}>{item.label}</Page>
                                        </span>
                                        ) : (
                                            <>
                                            {(index == 0) ? (


                                                <span index={index}
                                                      className={'visible pagination-page-wrapper'}
                                                      key={index}>
                                            <PageArrow
                                                className="visible"
                                                onClick={() => {this.props.pullClips(false, this.props.paginationMeta.current_page == 1 ? 1 : this.props.paginationMeta.current_page - 1);}}>
                                                {"<"}
                                            </PageArrow>
                                            </span>
                                            ) : (

                                                <span index={index}
                                                      className={'visible pagination-page-wrapper'}
                                                      key={index}>
                                            <PageArrow
                                                className="visible"
                                                onClick={() => {this.props.pullClips(false, this.props.paginationMeta.current_page == this.props.paginationMeta.last_page ? this.props.paginationMeta.last_page : this.props.paginationMeta.current_page + 1);}}>
                                                {">"}
                                            </PageArrow>
                                            </span>
                                            )}
                                            </>
                                        )}
                                        </React.Fragment>
                                    ))}
                                </Pages>
                                </>
                            ) : (
                                <></>
                            )}
                        </Pagination>
                    </TabContent>
                </ClipMenuWrapper>
            </div>

        );
    }
}
